import Alpine from "alpinejs";

Alpine.start();

